module.exports = __webpack_public_path__ + "img/1.1463d67d.png";